module.exports = __webpack_public_path__ + "img/Stand.500b98fd.svg";